// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/SimilarModule/similarModule.scss
// module id = 1440
// module chunks = 10 21